import React, { PureComponent } from "react";
import { FlipNumbers, Color, ColorProps, GlobalColorPalette } from "@gago/frame";
import styled from "styled-components";
// tslint:disable:ter-max-len variable-name

const GaugeLegendRoot = styled.div`
  margin-top: 12px;
  position: relative;
  display: flex;
  height: 24px;
  justify-content: space-around;
  align-items: center;
  font-size: 12px;
  .label-name {
    font-size: 14px;
    font-weight: 500;
    color: #eafbff;
    line-height: 1;
  }
  .label-value {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .label-count {
      font-family: BebasNeue;
      font-size: 28px;
      line-height: 1;
      color: #00daff;
      section {
        span {
          width: 10px !important;
        }
      }
    }
    .label-unit {
      margin-left: 4px;
      font-size: 12px;
      line-height: 1;
      color: #00daff;
    }
  }
.label-right {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-left: 28px; */
}
`;

const LabelIcon = styled.div<{type: "up" | "down"}>`
  position: relative;
  width: 20px;
  height: 20px;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 20px;
    height: 20px;
    opacity: 0.65;
    clip-path: polygon(${props => props.type === "up" ? "0 50%, 50% 0, 100% 50%, 75% 50%, 75% 100%, 25% 100%, 25% 50%" : "25% 0, 75% 0, 75% 50% , 100% 50% , 50% 100% , 0 50% , 25% 50%"});
    background: ${props => props.type === "up" ? "#82e0ff" : "#ff9216"};
  }
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 20px;
    height: 20px;
    margin-left: -6px;
    margin-top: -2px;
    opacity: 0.18;
    clip-path: polygon(${props => props.type === "up" ? "0 50%, 50% 0, 100% 50%, 75% 50%, 75% 100%, 25% 100%, 25% 50%" : "25% 0, 75% 0, 75% 50% , 100% 50% , 50% 100% , 0 50% , 25% 50%"});
    background: ${props => props.type === "up" ? "#82e0ff" : "#ff9216"};
  }
`;

type GaugeLegendProps= {
  /** 当前值 */
  currentValue: number;
  /** 当前的单位 */
  currentSuffix: string;
  /** 比率 */
  ratio: number;
} & ColorProps<GlobalColorPalette>;

/**
 * 大屏仪表盘图例 改版
 * @author 马俊峰
 * @date 2020-06-29
 * @export
 * @class GaugeLegend
 * @extends {PureComponent<GaugeLegendProps>}
 */
export default class GaugeLegend extends PureComponent<GaugeLegendProps> implements Color {
  render() {
    const { currentValue, currentSuffix, ratio, colorPalette: { subColor } } = this.props;
    return (
      <GaugeLegendRoot>
        <div className="label-value">
          <span className="label-count">
            <FlipNumbers
              height={24}
              width={24}
              color={"#fff"}
              delay={0}
            >
              {String(currentValue)}
            </FlipNumbers>
          </span>
          <div className="label-unit">{currentSuffix}</div>
        </div>
        <div className="label-right">
          <LabelIcon type={ratio >= 0 ? "up" : "down"}/>
          <div className="label-value">
            <span className="label-count">
              <FlipNumbers
                height={24}
                width={24}
                color={subColor[1]}
                delay={0}
              >
                {String(Math.abs(ratio))}
              </FlipNumbers>
            </span>
            <div className="label-unit" style={{ color: subColor[1] }}>%</div>
          </div>
        </div>
      </GaugeLegendRoot>
    );
  }
}
